import { TbRosetteDiscountCheck } from "react-icons/tb";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "./button";

interface ExerciseCompletionProps {
  onFinish: () => void;
  onRepeat: () => void;
  completionMessageId?: string;
  completionExerciseNameMessageId?: string;
  finishButtonMessageId?: string;
  repeatButtonMessageId?: string;
}

export default function ExerciseCompletion({
  onFinish,
  onRepeat,
  completionMessageId = "common.complete",
  completionExerciseNameMessageId,
  finishButtonMessageId = "common.finishExercise",
  repeatButtonMessageId = "common.repeatExercise",
}: ExerciseCompletionProps) {
  const intl = useIntl();
  const exerciseName = completionExerciseNameMessageId
    ? intl.formatMessage({ id: completionExerciseNameMessageId })
    : undefined;

  return (
    <div className="space-y-5 mx-auto max-w-md bg-background p-5 rounded-xl">
      <div>
        <TbRosetteDiscountCheck className="text-primary mx-auto" size={153} />
      </div>
      <div className="space-y-6">
        <h1 className=" text-black text-center font-medium">
          <FormattedMessage id={completionMessageId} values={exerciseName ? { exerciseName } : undefined} />
        </h1>
        <div className="flex gap-3">
          <Button className="w-full cursor-pointer" variant="secondary" onClick={onFinish}>
            <FormattedMessage id={finishButtonMessageId} />
          </Button>
          <Button className="w-full cursor-pointer" onClick={onRepeat}>
            <FormattedMessage id={repeatButtonMessageId} />
          </Button>
        </div>
      </div>
    </div>
  );
}
